import React, { useState, useEffect, useRef } from 'react'

const FAST_INTERVAL = 180000 // 3 minutes
const SLOW_INTERVAL = 180000 // 3 minutes

const RefreshContext = React.createContext({ slow: 0, fast: 0 })

// Check if the tab is active
const useIsBrowserTabActive = () => {
  const isBrowserTabActiveRef = useRef(true)

  useEffect(() => {
    const onVisibilityChange = () => {
      isBrowserTabActiveRef.current = !document.hidden
    }

    window.addEventListener('visibilitychange', onVisibilityChange)
    return () => window.removeEventListener('visibilitychange', onVisibilityChange)
  }, [])

  return isBrowserTabActiveRef
}

const RefreshContextProvider = ({ children }) => {
  const [slow, setSlow] = useState(0)
  const [fast, setFast] = useState(0)
  const isBrowserTabActiveRef = useIsBrowserTabActive()

  useEffect(() => {
    const fastInterval = setInterval(() => {
      if (isBrowserTabActiveRef.current) {
        setFast((prev) => prev + 1)
      }
    }, FAST_INTERVAL)
    return () => clearInterval(fastInterval)
  }, [isBrowserTabActiveRef])

  useEffect(() => {
    const slowInterval = setInterval(() => {
      if (isBrowserTabActiveRef.current) {
        setSlow((prev) => prev + 1)
      }
    }, SLOW_INTERVAL)
    return () => clearInterval(slowInterval)
  }, [isBrowserTabActiveRef])

  return <RefreshContext.Provider value={{ slow, fast }}>{children}</RefreshContext.Provider>
}

export { RefreshContext, RefreshContextProvider }
